import React from 'react';
import { FormControl, InputLabel, Select, MenuItem, InputAdornment, Box } from '@mui/material';
import { HandymanOutlined } from '@mui/icons-material';
import { usePMDetailsEditor } from '../../../../hooks/usePMDetailsEditor';
import { useGetRepairableByOptionsQuery } from '../../../../../../services/DimensionService/dimensionApi';
import { EditorMode } from '../../../../types/editorTypes';

interface Props {
  mode: EditorMode;
}

/**
 * PMPerformedByEditor - Select editor for the "Performed By" field on PM tickets.
 * Uses the same RepairableBy SmartEnum options (Staff/Vendor/TBD).
 */
export const PMPerformedByEditor: React.FC<Props> = ({ mode }) => {
  const { pmDetails, updatePMField } = usePMDetailsEditor(mode);
  const { data: options = [], isLoading } = useGetRepairableByOptionsQuery();
  const labelId = `${mode}-pm-performed-by-label`;

  const handleChange = (value: string) => {
    updatePMField({ performedBy: value });
  };

  return (
    <Box sx={{ flex: 1 }}>
      <FormControl size="small" fullWidth>
        <InputLabel id={labelId}>Performed By</InputLabel>
        <Select
          labelId={labelId}
          value={pmDetails?.performedBy || ''}
          onChange={(e) => handleChange(e.target.value)}
          label="Performed By"
          disabled={isLoading}
          startAdornment={
            <InputAdornment position="start">
              <HandymanOutlined sx={{ color: '#64748b', fontSize: 18 }} />
            </InputAdornment>
          }
        >
          {options.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

export default PMPerformedByEditor;
